/**
 * The page's BCP 47 locale for `Intl`, Stripe and other widgets: `<html data-locale>`, the `Locale` enum's
 * `htmlLang()`. Not `<html lang>`: translation proxies such as translate.goog rewrite it to their target
 * language. A document without `data-locale` renders the source locale, as `t()` does.
 * Free of `translate.js`, so modules behind `boot.js` may import it.
 * @returns {string}
 */
export function documentLocale() {
    return document.documentElement.dataset.locale || 'en';
}
